import { render } from "./Picture.vue?vue&type=template&id=5010ab24&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"

import "./Picture.vue?vue&type=style&index=0&id=5010ab24&lang=scss"
import "./Picture.vue?vue&type=style&index=1&id=5010ab24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5010ab24"

export default script